import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';

const authUrl = `${SERVER_API}/auth`;
const esiaUrl = `${SERVER_API}/esia`;
const ugraidUrl = `${SERVER_API}/ugraid`;
const yandexCaptchaUrl = `${SERVER_API}/yandex-captcha`;

export const AUTHORIZATION = {
  LOGIN: {
    method: 'POST',
    url: `${authUrl}/login`,
  } as IEndpointData,
  LOGOUT: {
    method: 'POST',
    url: `${authUrl}/logout`,
  } as IEndpointData,
  REFRESH_TOKEN: {
    method: 'POST',
    url: `${authUrl}/refresh-token`,
  } as IEndpointData,
  REGISTER: {
    method: 'POST',
    url: `${authUrl}/register`,
  } as IEndpointData,
  RESET_PASSWORD: {
    method: 'POST',
    url: `${authUrl}/reset-password`,
  } as IEndpointData,
  RESET_PASSWORD_CONFIRM: {
    method: 'POST',
    url: `${authUrl}/reset-password-confirm`,
  } as IEndpointData,
  CHANGE_TEMP_PASSWORD: {
    method: 'POST',
    url: `${authUrl}/change-temp-password`,
  } as IEndpointData,
  ESIA_AUTH_URL: {
    method: 'GET',
    url: `${esiaUrl}/oauth-url`,
  } as IEndpointData,
  ESIA_LOGIN: {
    method: 'POST',
    url: `${esiaUrl}/login`,
  } as IEndpointData,
  UGRA_ID_AUTH: {
    method: 'GET',
    url: `${ugraidUrl}/auth`,
  } as IEndpointData,
  YANDEX_CAPTCHA: {
    method: 'POST',
    url: `${yandexCaptchaUrl}`,
  } as IEndpointData,

};
